import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getInventoryConsolidateProducts } from '../../../../../actions/inventoryActions'
import ProductsConsolidationView from '../../../../containers/Inventory/InventoryLocations/ProductsConsolidation/ProductsConsolidation'

const ProductsConsolidation = () => {
    const limitConsolidateProducts=50;
    
    const dispatch = useDispatch();
    const { inventoryConsolidateProducts } = useSelector(state => state.inventory)
    const [skipConsolidateProducts, setSkipConsolidateProducts] = useState(0);
    

    useEffect(() => {
        dispatch(getInventoryConsolidateProducts(skipConsolidateProducts, limitConsolidateProducts));
        
    }, [skipConsolidateProducts]);
    
    return (
        <ProductsConsolidationView
            consolidateProducts={inventoryConsolidateProducts}
            setSkipConsolidateProducts={setSkipConsolidateProducts} 
            limitConsolidateProducts={limitConsolidateProducts}/>
    )
}

export default ProductsConsolidation